
























































import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

interface Entry {
  id: number;
  center_id: number;
  remaining_credits: number;
}

@Component({
  name: 'bpc-adjust-entry-form-form',
  components: {
    'bpc-form-provider': FormProvider,
  },
})
export default class AdjustEntryForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  @Prop({ type: Object }) readonly entry: Entry;

  // DATA
  public formModel: Partial<Entry> = {
    remaining_credits: null,
  };

  // LIFECYCLE
  mounted() {
    this.initFormModel();
  }

  // COMPUTED

  get savePath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath('entry')}/adjust-credits`;
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 pl-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 pl-2': true,
        },
      },
    };
  }
  get creditsToAdd() {
    return this.formModel.remaining_credits - this.entry.remaining_credits;
  }
  // METHODS
  initFormModel() {
    console.log(this.formModel);
    this.formModel.remaining_credits = this.entry.remaining_credits;
  }

  incrementEntry() {
    this.formModel.remaining_credits++;
  }
  decrementEntry() {
    this.formModel.remaining_credits--;
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.superadmin_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  // WATCHERS
}
